export default "__VITE_ASSET__YwcdTkMY__"